module.exports = __webpack_public_path__ + "icofont.f6ab04aed30a8643bf94";


//////////////////
// WEBPACK FOOTER
// /home/arsalan/Desktop/Dev Stack/Otacon (npm start)/src/assets/icofont/fonts/icofont.woff
// module id = ../../../../../src/assets/icofont/fonts/icofont.woff
// module chunks = main